import { ValidationErrors } from 'final-form';

const validate = (values: ArmyBookParams): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!values.name) {
    errors.client = 'Name is required.';
  }
  if (!values.version) {
    errors.affaire = 'Version is required.';
  }

  return errors;
};
export default validate;

export type ArmyBookParams = {
  name: string;
  version: string;
  loc: {
    name: string;
    value: string;
  }[];
};
